__turbopack_context__.v({
  "active-bg": "Pr0bMq_active-bg",
  "active-tab-background": "Pr0bMq_active-tab-background",
  "tab": "Pr0bMq_tab",
  "tab-bar": "Pr0bMq_tab-bar",
  "theme-moss": "Pr0bMq_theme-moss",
  "theme-smoke": "Pr0bMq_theme-smoke",
  "theme-standard": "Pr0bMq_theme-standard",
});
